import { brazilDateToISO } from 'Services/extraDate'
import { userAvatar } from 'Services/avatarGenerator'
import isNull from 'lodash/isNull'
import parse from 'date-fns/parse'
import formatDistanceStrict from 'date-fns/formatDistanceStrict'
import { default as locale } from 'date-fns/locale/pt-BR'
import addDays from 'date-fns/addDays'
import format from 'date-fns/format'
import parseISO from 'date-fns/parseISO'

/** * @param {ApiReviewCompany} data */
const parseUser = (data) => {
  return {
    name: data.userName,
    photo: userAvatar(data.userPhotoPath, data.userName),
    building: data.addressDescription,
    city: data.addressCity,
    state: data.addressUf,
  }
}
const parseCompany = (data) => {
  return {
    name: data.companyName,
    photo: userAvatar(data.companyPhotoUrl, data.companyName),
    building: data.addressDescription,
    city: data.addressCity,
    state: data.addressUf,
  }
}

/** * @param {ApiReviewCompany} data */
const parseRating = (data) => {
  const score = isNull(data.rating)
    ? null
    : parseInt(data.rating)

  return {
    score,
    comment: data.comment,
    created: data.dateCreated,
    updated: data.edited || false,
  }
}

/** * @param {ApiReviewCompany} data */
const parseReply = (reply, edited?) => {
    const id = reply !== null
      ? reply.id
      : null

    const comment = reply !== null && typeof reply === 'object'
      ? reply.comment
      : reply

    const created = reply !== null
      ? reply.dateCreated
      : null

    const updated = reply !== null
      ? edited || false
      : false

    return { id, comment, created, updated }

}


/**
 * @param {string} quotationDate
 * @param {string} dateCreated
 * @param {number} daysAgo
 * @returns {string}
 */
const parseCurrentDate = (quotationDate, dateCreated, daysAgo) => {
  const quotation = parse(quotationDate, 'dd/MM/yyyy', new Date())
  const review = parse(dateCreated, 'dd/MM/yyyy', new Date())
  const today = addDays(review, daysAgo)

  return formatDistanceStrict(quotation, today, { locale })
}

/**
 * @param {number} dateCreated
 * @param {number} daysAgo
 * @returns {string}
 */
const parseMigratedDate = (dateCreated, daysAgo) => {
  const review = parse(dateCreated, 'dd/MM/yyyy', new Date())
  const today = addDays(review, daysAgo)

  return formatDistanceStrict(review, today, { locale })
}

/**
 * @param {ApiReviewCompany} data
 * @returns {string}
 */
const parseEllapsedTime = (data) => {
  const { quotationDate, dateCreated, daysAgo } = data

  return quotationDate === null
    ? parseMigratedDate(dateCreated, daysAgo)
    : parseCurrentDate(quotationDate, dateCreated, daysAgo)
}

/**
 * @param {ApiReviewCompany} data
 * @returns {ReviewCompany}
 */
export const parseReview = (data) => {
  const createdSince = parseEllapsedTime(data)
  const user = parseUser(data)
  const rating = parseRating(data)
  const reply = parseReply(data.evaluationReply, data.edited)

  return {
    id: data.id,
    idNegotiation: data.idCompanyQuotation,
    token: data.quotationCode,
    serviceType: data.quotationServiceType,
    unread: false,
    createdSince,
    user,
    rating,
    reply,
  }
}

export const parseUserReview = (data) => {
  const user = parseCompany(data)
  const rating = parseRating(data)
  const reply = parseReply(data.reply)
  const createdSince = formatDistanceStrict(parseISO(data.dateCreated), new Date(), { locale, roundingMethod: 'ceil' })

  return {
    id: data.id,
    idNegotiation: data.companyId,
    unread: false,
    createdSince,
    user,
    rating,
    reply,
    new: data.newEvaluation,
    author: data.evaluationAuthor,
    idCompanyQuotation: data.idCompanyQuotation,
    serviceType: data.serviceType,
    token: data.identifier
  }
}

export default {
  parseReview,
  parseUserReview
}